import moment from "moment";
import { DateTimeFormats } from "../constants/Constants";

const invalidDate = "Invalid date";

export default class DateHelper {
  static getDateInStringFormat(date) {
    const dateInMoment = moment(date, DateTimeFormats.apiMask);
    if (dateInMoment.format() === invalidDate) {
      return date;
    }
    return dateInMoment.format(DateTimeFormats.apiMaskWithDateForDisplay);
  }

  static getRenewalFormat(date){
    const dateInMoment = moment(date, DateTimeFormats.apiMask);
    if (dateInMoment.format() === invalidDate) {
      return date;
    }
    return(moment(date).format('DD-MMMM-YYYY').replaceAll('-', ' ')); 
  }

  static getTimeInStringFormat(date) {
    const dateInMoment = moment(date, DateTimeFormats.apiMaskWithTime);
    if (dateInMoment.format() === invalidDate) {
      return date;
    }
    return dateInMoment.format(DateTimeFormats.apiMaskWithTimeForDisplay);
  }

  static getDateAndTimeInStringFormat(date) {
    const dateInMoment = moment(date, DateTimeFormats.apiMaskWithTime);
    if (dateInMoment.format() === invalidDate) {
      return date;
    }
    return dateInMoment.format(
      DateTimeFormats.apiMaskWithDateAndTimeForDisplay
    );
  }

  static isAgeAbove18(date){
    const birthDate = new Date(date);
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    const dayDifference = today.getDate() - birthDate.getDate();

    if (monthDifference > 0 || (monthDifference === 0 && dayDifference >= 0)) {
      return age >= 18;
      } else {
        return age > 18;
    }
  }
}
